export type Tier = 'starter' | 'plus' | 'pro' | 'max';
export type Cycle = 'monthly';
export type Plan = {
  id: Tier;
  name: string;
  monthly_amount_cents: number;
  monthly_stars: number;
  monthly_discount_bps: number;
};
export type Content = {
  id: string;
  kind: 'resource' | 'self_paced' | 'course_discount';
  content_id: string;
  minimum_tier: Tier;
  title: string;
  published: boolean;
  body_md?: string;
};
export type Catalog = {
  revision: number;
  quote_token: string | null;
  quote_expires_at?: string | null;
  version: string;
  currency: 'AUD';
  plans: Plan[];
  purchase_available: boolean;
  terms_url: string | null;
  tax_included: boolean | null;
  content: Content[];
};
export type Summary = {
  wallet_balance?: number | null;
  membership_stars?: number | null;
  recharge_stars?: number | null;
  membership_allowance?: number;
  membership_expires_at?: string | null;
  allowance_events?: {reason:string;delta_stars:number;created_at:string}[];
  next_stars_at?: string | null;
  next_payment_at?: string | null;
  status: string;
  tier: Tier | null;
  cycle: Cycle | null;
  effective_tier: Tier | null;
  period_end: string | null;
  anchor_at: string | null;
  cancel_at_period_end: boolean;
  pending_change: { tier: Tier; cycle: Cycle; effective_at: string } | null;
  content: Content[];
  grants: { id: string; cycle_start: string; stars: number; created_at: string }[];
  invoices: {
    invoice_id: string;
    amount_cents: number;
    currency: string;
    starts_at: string;
    ends_at: string;
    invoice_url: string | null;
    pdf_url: string | null;
  }[];
};
export type MembershipClient = {
  previewNextPaidMonth?: () => Promise<void>;
  catalog: () => Promise<Catalog>;
  current: () => Promise<Summary>;
  action: (
    kind: 'checkout' | 'cancel' | 'resume' | 'change' | 'reconcile',
    body: unknown,
  ) => Promise<{ checkout_url?: string; status?: string }>;
  resource: (id: string) => Promise<Content>;
};
export const money = (cents: number) =>
  `A$${(cents / 100).toLocaleString('en-AU', { minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 })}`;
